/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import KioskSlider from '../../KioskSlider';
import RangePicker from '../../../CustomizedAntDesign/RangePicker';
import useSearchParams from '../../../../hooks/useSearchParams';
import { useEffect } from 'react';
import fixRangeDates from '../../../../utils/fixRangeDates';

const AnniversaryFilter = props => {

  const {setValue: setSearchParams, getAll} = useSearchParams();
  const params = getAll();

  const [itemOpen, setItemOpen] = useState(false);
  const [anniversaryRange, setAnniversaryRange] = useState([null, null]);
  const [hasAnniversaryValue, setHasAnniversaryValue] = useState(false);
  const [hasDoesNotHaveAnniversaryValue, setHasDoesNotHaveAnniversaryValue] = useState(false);

  const someFilterSelected = useMemo(
    () => params?.filterAnniversaryDateRange?.some(item => item !== null) || params?.filterHasAnniversary || params?.filterHasDoesNotHaveAnniversary,
    [params],
  );

  const handleChangeAnniversaryDateRange = value => {
    setSearchParams('filterAnniversaryDateRange', value ? `${value[0].format('MMDD')},${value[1].format('MMDD')}` : null);
    setSearchParams('filterHasAnniversary', false);
    setSearchParams('filterHasDoesNotHaveAnniversary', false);
  };

  useEffect(() => {
    if(params?.filterAnniversaryDateRange && params.filterAnniversaryDateRange.filter(item => item !== null).length > 0) {
      setAnniversaryRange(fixRangeDates(params?.filterAnniversaryDateRange))
    } else {
      setAnniversaryRange([null, null])
    }
    if(params?.filterHasAnniversary){
      setHasAnniversaryValue(true)
    } else {
      setHasAnniversaryValue(false)
    }
    if(params?.filterHasDoesNotHaveAnniversary){
      setHasDoesNotHaveAnniversaryValue(true)
    } else {
      setHasDoesNotHaveAnniversaryValue(false)
    }
  }, [window.location.search])

  const handleChangeHasAnniversary = value => {
    setSearchParams('filterAnniversaryDateRange', false)
    setSearchParams('filterHasAnniversary', value);
    setSearchParams('filterHasDoesNotHaveAnniversary', false);
  };

  const handleChangeHasDoesNotHaveAnniversary = value => {
    setSearchParams('filterAnniversaryDateRange', false)
    setSearchParams('filterHasAnniversary', false);
    setSearchParams('filterHasDoesNotHaveAnniversary', value);
  };

  const handleClear = event => {
    event.stopPropagation();

    setSearchParams('filterAnniversaryDateRange', false)
    setSearchParams('filterHasAnniversary', false);
    setSearchParams('filterHasDoesNotHaveAnniversary', false);
  };

  return (
    <div className="filter-item-container">
      <div className="filter-item-header" onClick={() => setItemOpen(!itemOpen)}>
        <div className="filter-item-header-title">Anniversary</div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {someFilterSelected && (
            <div className="filter-item-clear" onClick={handleClear}>
              Clear
            </div>
          )}

          <FontAwesomeIcon
            icon={['far', `${itemOpen ? 'chevron-up' : 'chevron-down'}`]}
            className="fs-16"
            color="#818181"
          />
        </div>
      </div>

      {itemOpen && (
        <div className="filter-item-list-container" style={{ marginTop: '0px' }}>
          <div className="filter-item-list-toggle" style={{ width: '100%' }}>
            <RangePicker
              format="MM/DD"
              value={anniversaryRange}
              onChange={handleChangeAnniversaryDateRange}
              popupStyle={{ zIndex: 10000000 }}
              showToday
            />
          </div>

          <div className="filter-item-list-toggle" style={{ display: 'flex', alignItems: 'center' }}>
            <KioskSlider value={hasAnniversaryValue} onChange={handleChangeHasAnniversary} />

            <span className="filter-item-list-toggle-span" style={{ marginRight: '8px' }}>
              Has Anniversary
            </span>

            <Tooltip
              title="This will return every client that has an anniversary in their client profile."
              placement="right"
              zIndex={10000000}
            >
              <InfoCircleOutlined />
            </Tooltip>
          </div>

          <div className="filter-item-list-toggle" style={{ display: 'flex', alignItems: 'center' }}>
            <KioskSlider value={hasDoesNotHaveAnniversaryValue} onChange={handleChangeHasDoesNotHaveAnniversary} />

            <span className="filter-item-list-toggle-span" style={{ marginRight: '8px' }}>
              Doesn&apos;t have Anniversary
            </span>

            <Tooltip
              title="This will return every client that doesn't have an anniversary in their client profile."
              placement="right"
              zIndex={10000000}
            >
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnniversaryFilter;
